import React from 'react';

// Contenedor responsive (móvil/escritorio) de la bottom bar de los visores
// 3D. Los botones los compone ModelViewerShell.jsx dentro de
// `mobile`/`desktop`.
const BottomBar = ({ mobile, desktop }) => (
    <div className="fixed bottom-0 left-0 right-0 z-50">
        <div className="bg-base-100/95 backdrop-blur-lg border-t border-base-300 px-4 py-3 shadow-2xl">
            <div className="flex items-center justify-between w-full lg:hidden">
                {mobile}
            </div>

            <div className="hidden lg:flex items-center justify-between max-w-4xl mx-auto w-full">
                {desktop}
            </div>

            <div className="h-safe-area-inset-bottom" />
        </div>
    </div>
);

export default BottomBar;
